import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SearchBoxModule } from '@common/search-box';
import { SharedUiSkeletonFormModule } from '@common/skeletons';
import { CustomerSelectorComponent } from './customer-selector.component';
import { RoutedCustomerSelectorComponent } from './routed.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatDialogModule,
    MatListModule,
    MatToolbarModule,
    MatSnackBarModule,
    SearchBoxModule,
    SharedUiSkeletonFormModule,
  ],
  declarations: [RoutedCustomerSelectorComponent, CustomerSelectorComponent],
  exports: [RoutedCustomerSelectorComponent, CustomerSelectorComponent],
})
export class CustomerSelectorModule {}
